require('angular').module('oly.common')
    .directive('wowScrollbar', ['$timeout', require('./scrollbar.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/scrollbar/index.js